import { render, staticRenderFns } from "./noWorkAssignments.vue?vue&type=template&id=12160dde&scoped=true"
import script from "./noWorkAssignments.vue?vue&type=script&lang=js"
export * from "./noWorkAssignments.vue?vue&type=script&lang=js"
import style0 from "./noWorkAssignments.vue?vue&type=style&index=0&id=12160dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12160dde",
  null
  
)

export default component.exports